import React from "react";
import fileUploadIcon from "assets/images/fileUpload.svg"; 
import removeImg from "assets/svgs/close.svg";
import server from "api/server";
import { handleImage } from "helpers/functions";
import { FormattedMessage } from "react-intl";
import FileCompleted from "assets/images/fileCompleted.svg"

const FileUpload = ({
  selectedFile,
  setSelectedFile,
  accept = "*/*",
  className = "",
}) => {
  const fileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      const { data } = await server().post("/upload", formData);
    
      setSelectedFile({
        preview: e.target.files[0],
        path: process.env.REACT_APP_URL + data.data.file.path,
      });
    }
  };

  const removeSelectedFile = () => {
    setSelectedFile(null);
  };

  return (
    <div className={`image-uploader image-contain  ${className}`}>
      <div className="img-pat">
        <img src={fileUploadIcon} width={46} height={46} alt="Upload File" className="filePdfIcon" />
      </div>
      <label>
        {(selectedFile?.preview || selectedFile?.path) && (
          <div>
            <a
              href={handleImage(selectedFile?.path)}
              target="_blank"
              rel="noreferrer"
              className="d-flex align-items-center h-100 gap-4 flex-column justify-content-center"
            >
              <img
                src={FileCompleted}
                alt="Upload File"
                className="filePdfIcon"
              />
              <FormattedMessage id="showFile" />
            </a>
            <button className="removeImg" onClick={removeSelectedFile}>
              <img src={removeImg} alt="Remove" />
            </button>
          </div>
        )}
        <input accept={accept} type="file" onChange={fileChange} />
      </label>
    </div>
  );
};

export default FileUpload;
